<template>
<div>
  <div class="status-msg my-md" v-if="isLoadingAttachmentDetails"
  >
    {{$t('INDENT_LOADING')}}....
  </div>
  <div class="status-msg my-md" v-else-if="showEmptyState"
  >
    <span>
      <svgicon name="empty-timeline" width="180" height="130" :original="true" />
      <p class="ml-30">{{$t('INDENT_NO_ATTACHMENTS_FOUND')}}</p>
    </span>
  </div>
  <div v-if="masterAttachmentList && masterAttachmentList.length">
    <div class="flex-item">
      <p>
        <strong class="text-blue-dark1">{{$t('INDENT_MASTER_ATTACHMENTS')}}</strong>
      </p>
    </div>
    <ul class="list-attachment list-multi">
      <li v-for="(attachmentDetail,index) in masterAttachmentList" :key="index">
        <label>{{attachmentDetail.label}}</label>
        <Attachments
          :attachments="attachmentDetail.details"
          :disableUpload="true"
          :showPreview="true"
        ></Attachments>
      </li>
    </ul>
  </div>
  <div v-if="roadLegAttachmentList && roadLegAttachmentList.length">
    <div class="flex-item">
      <p>
        <strong class="text-blue-dark1">{{$t('INDENT_ROAD_ATTACHMENTS')}}</strong>
      </p>
    </div>
    <ul class="list-attachment list-multi">
      <li v-for="(attachmentDetail,index) in roadLegAttachmentList" :key="index">
        <label>{{attachmentDetail.label}}</label>
        <Attachments
          :attachments="attachmentDetail.details"
          :disableUpload="true"
          :showPreview="true"
        ></Attachments>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { FIELD_TYPES } from 'pando-constants';

import Attachments from '@common/components/AttachmentsPopup';

export default {
  props: ['selectedIndent'],
  components: {
    Attachments,
  },
  data() {
    return {
      masterAttachmentList: [],

      roadLegAttachmentList: [],
      isLoadingAttachmentDetails: true,
    };
  },
  async created() {
    this.isLoadingAttachmentDetails = true;
    await this.fetchAttachments();
  },
  computed: {
    ...mapGetters({
      currentClientConfig: 'app/currentClientConfig',
    }),
    showEmptyState() {
      return (!this.masterAttachmentList || !this.masterAttachmentList.length) &&
        (!this.roadLegAttachmentList || !this.roadLegAttachmentList.length);
    },
  },
  methods: {
    async fetchAttachments() {
      try {
        // master level attachment changes
        this.masterAttachmentList = this.getMasterAttachments();
        this.roadLegAttachmentList = [];
        // road leg detail
        const attachmentsList = await this.setRoadLegAttachment(this.selectedIndent);
        if (attachmentsList && attachmentsList.length) {
          this.roadLegAttachmentList = attachmentsList;
        }
        this.isLoadingAttachmentDetails = false;
      } catch (err) {
        this.isLoadingAttachmentDetails = false;
      }
    },
    getMasterAttachments() {
      // master level attachment changes
      const creationAttachmentConfig = this.currentClientConfig && this.currentClientConfig.exim_attachments;
      const attachmentList = [];
      // attachments during creation
      if (creationAttachmentConfig && this.selectedIndent.master_attachments) {
        const indentAttachments = this.selectedIndent.master_attachments;
        creationAttachmentConfig.forEach((attachConfig) => {
          if (attachConfig.active) {
            const attachDetails = indentAttachments[attachConfig.key];
            if (attachDetails) {
              const attachObj = {
                label: attachConfig.label,
                details: attachDetails && attachDetails.map(attachDetail => ({
                  name: attachDetail.content_file_name,
                  url: attachDetail.metadata.location,
                  id: attachDetail._id,
                })),
              };
              attachmentList.push(attachObj);
            }
          }
        });
      }
      if (this.selectedIndent.master_container_details_attachments &&
        this.selectedIndent.master_container_details_attachments.length) {
        const attachDetails = this.selectedIndent.master_container_details_attachments.map(attachDetail => ({
          name: attachDetail.content_file_name,
          url: attachDetail.metadata.location,
          id: attachDetail._id,
        }));
        attachmentList.push({
          label: this.$t('INDENT_CONTAINER_BOOKING_DOCUMENT'),
          details: attachDetails });
      }
      return attachmentList;
    },
    async setRoadLegAttachment(roadLegDetails) {
      const roadLegAttachmentList = [];
      if (roadLegDetails.flow.exim_document_fields) {
        let truckoutAttachmentArray = [];
        const truckoutConfig = (this.currentClientConfig &&
          this.currentClientConfig.exim_document_fields) || [];
        truckoutConfig.forEach((config) => {
          if (config.type === FIELD_TYPES.ATTACHMENT) {
            const attachmentIds = roadLegDetails.flow.exim_document_fields[config.name];
            if (attachmentIds) {
              truckoutAttachmentArray = truckoutAttachmentArray.concat(attachmentIds);
            }
          }
        });
        if (truckoutAttachmentArray && truckoutAttachmentArray.length) {
          const truckoutAttachmentDetails =
            await this.$store.dispatch('indents/getAttachmentsByIds',
              { ids: truckoutAttachmentArray.join(','), client_id: this.currentClientConfig.client_id,
              });
          truckoutConfig.forEach((config) => {
            if (config.type === FIELD_TYPES.ATTACHMENT) {
              const attachmentIds = roadLegDetails.flow.exim_document_fields[config.name];
              const attachmentDetails = attachmentIds.map((attachmentId) => {
                const attachmentDetail = truckoutAttachmentDetails.find(val => val.id === attachmentId);
                return {
                  name: attachmentDetail.name,
                  url: attachmentDetail.attachment_url,
                  id: attachmentId,
                };
              });
              roadLegAttachmentList.push({
                label: config.label,
                details: attachmentDetails,
              });
            }
          });
        }
      }
      return roadLegAttachmentList;
    },
  },
};
</script>
